// @ts-strict-ignore
import React from 'react'
import { History } from 'history'
import { withRouter, RouteComponentProps } from 'react-router'
import { routerMiddleware } from 'connected-react-router'
import { sendPathname } from '../logging/analytics'
import { history } from './history'
import { storeDeferredDeepLinkingURLIfNeeded } from '../platform/deferredDeepLinking'

export const middleware = routerMiddleware(history)

export let ionHistory: History

class IonicNavigation extends React.PureComponent<RouteComponentProps> {
	unListen: () => void

	pathname = ''
	hash = ''
	searchParams: Record<string, string> = {}

	componentDidMount() {
		// Fix for ionic router
		ionHistory = this.props.history

		sendPathname(ionHistory.location.pathname, undefined, ionHistory.location.hash, ionHistory.location.search)
		storeDeferredDeepLinkingURLIfNeeded()

		// When Safari serves an already-loaded page (restored from the back/forward
		// cache, or an existing tab brought back to the foreground) the component is
		// not remounted and no route change fires, so the DDL store above never runs
		// for that visit. Re-store the URL on those events so the latest page is
		// recorded for deferred deep linking. See sc-148640.
		window.addEventListener('pageshow', this.handlePageShow)
		document.addEventListener('visibilitychange', this.handleVisibilityChange)

		this.unListen = ionHistory.listen(({ pathname, state, hash, search }) => {
			if (hash === '#transcript' || this.hash === '#transcript') {
				return
			}

			const searchParams = Object.fromEntries(new URLSearchParams(search).entries())

			// prevent multiple sending the same page view event
			// Use `areSearchParamsEqual` to check if it's still the same params but in different order (seen with map view)
			if (
				pathname !== this.pathname ||
				hash !== this.hash ||
				!this.areSearchParamsEqual(searchParams, this.searchParams)
			) {
				sendPathname(pathname, state, hash, search)
				storeDeferredDeepLinkingURLIfNeeded()
				this.pathname = pathname
				this.hash = hash
				this.searchParams = searchParams
			}
		})
	}

	componentWillUnmount() {
		this.unListen()
		window.removeEventListener('pageshow', this.handlePageShow)
		document.removeEventListener('visibilitychange', this.handleVisibilityChange)
	}

	// Restored from the back/forward cache — scripts don't re-run, only `pageshow`
	// fires (with `persisted` set). A fresh load is already covered by componentDidMount.
	handlePageShow = (event: PageTransitionEvent) => {
		if (event.persisted) {
			storeDeferredDeepLinkingURLIfNeeded()
		}
	}

	// An already-open tab brought back to the foreground fires `visibilitychange`
	// without a `pageshow`, so catch that case too.
	handleVisibilityChange = () => {
		if (document.visibilityState === 'visible') {
			storeDeferredDeepLinkingURLIfNeeded()
		}
	}

	areSearchParamsEqual(searchParams1: Record<string, string>, searchParams2: Record<string, string>) {
		const keys1 = Object.keys(searchParams1)
		const keys2 = Object.keys(searchParams2)

		if (keys1.length !== keys2.length) {
			return false
		}

		for (const key of keys1) {
			if (searchParams1[key] !== searchParams2[key]) {
				return false
			}
		}

		return true
	}

	render() {
		return null
	}
}

export default withRouter(IonicNavigation)
